import React, { useRef, useState, useCallback } from 'react'
import './style.css'
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import { Navigation, Autoplay } from 'swiper/modules';

const ConsumerSay = () => {
    const sliderRef = useRef();

    const [isBeginning, setIsBeginning] = useState(true);
    const [isEnd, setIsEnd] = useState(false);

    const handlePrev = useCallback(() => {
        if (!sliderRef.current) return;
        sliderRef.current.swiper.slidePrev();
    }, []);

    const handleNext = useCallback(() => {
        if (!sliderRef.current) return;
        sliderRef.current.swiper.slideNext();
    }, []);

    const handleSlideChange = (swiper) => {
        setIsBeginning(swiper.isBeginning);
        setIsEnd(swiper.isEnd);
    };


    return (
        <>
            <div className="consumer-says-box">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <h1 className='home-main-heading'>What Our Consumer Say</h1>
                        </div>

                        <div className="col-md-12">
                            <div className="consumer-card-box">
                                <div className="slider-container">
                                    <Swiper
                                        slidesPerView={'4'}
                                        spaceBetween={30}
                                        navigation={false}
                                        autoplay={{
                                            delay: 2000,
                                            disableOnInteraction: false,
                                            pauseOnMouseEnter: true,
                                        }}
                                        modules={[Navigation]}
                                        onSlideChange={handleSlideChange}
                                        className="mySwiper"
                                        ref={sliderRef}
                                        breakpoints={{
                                            425: {
                                                slidesPerView: 1,
                                                spaceBetween: 0,
                                            },
                                            375: {
                                                slidesPerView: 1,
                                                spaceBetween: 0,
                                            },
                                            320: {
                                                slidesPerView: 1,
                                                spaceBetween: 0,
                                            },
                                            780: {
                                                slidesPerView: 3,
                                                spaceBetween: 0,
                                            },
                                            768: {
                                                slidesPerView: 3,
                                                spaceBetween: 0,
                                            },
                                            1280: {
                                                slidesPerView: 4,
                                                spaceBetween: 0,
                                            },
                                        }}
                                    >
                                        <SwiperSlide>
                                            <div className="comsumer-say-card">
                                                <p className="common-text">"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Doloribus nisi enim quo quasi facilis reprehenderit accusamus qui culpa error eius aut adipisci sunt, nesciunt optio? Ducimus sed debitis,"</p>
                                                <h3>- John Doe</h3>
                                            </div>
                                        </SwiperSlide>

                                        <SwiperSlide>
                                            <div className="comsumer-say-card">
                                                <p className="common-text">"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Doloribus nisi enim quo quasi facilis reprehenderit accusamus qui culpa error eius aut adipisci sunt, nesciunt optio? Ducimus sed debitis,"</p>
                                                <h3>- John Doe</h3>
                                            </div>
                                        </SwiperSlide>

                                        <SwiperSlide>
                                            <div className="comsumer-say-card">
                                                <p className="common-text">"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Doloribus nisi enim quo quasi facilis reprehenderit accusamus qui culpa error eius aut adipisci sunt, nesciunt optio? Ducimus sed debitis,"</p>
                                                <h3>- John Doe</h3>
                                            </div>
                                        </SwiperSlide>

                                        <SwiperSlide>
                                            <div className="comsumer-say-card">
                                                <p className="common-text">"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Doloribus nisi enim quo quasi facilis reprehenderit accusamus qui culpa error eius aut adipisci sunt, nesciunt optio? Ducimus sed debitis,"</p>
                                                <h3>- John Doe</h3>
                                            </div>
                                        </SwiperSlide>


                                        <SwiperSlide>
                                            <div className="comsumer-say-card">
                                                <p className="common-text">"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Doloribus nisi enim quo quasi facilis reprehenderit accusamus qui culpa error eius aut adipisci sunt, nesciunt optio? Ducimus sed debitis,"</p>
                                                <h3>- John Doe</h3>
                                            </div>
                                        </SwiperSlide>

                                        <SwiperSlide>
                                            <div className="comsumer-say-card">
                                                <p className="common-text">"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Doloribus nisi enim quo quasi facilis reprehenderit accusamus qui culpa error eius aut adipisci sunt, nesciunt optio? Ducimus sed debitis,"</p>
                                                <h3>- John Doe</h3>
                                            </div>
                                        </SwiperSlide>

                                        <SwiperSlide>
                                            <div className="comsumer-say-card">
                                                <p className="common-text">"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Doloribus nisi enim quo quasi facilis reprehenderit accusamus qui culpa error eius aut adipisci sunt, nesciunt optio? Ducimus sed debitis,"</p>
                                                <h3>- John Doe</h3>
                                            </div>
                                        </SwiperSlide>

                                        <SwiperSlide>
                                            <div className="comsumer-say-card">
                                                <p className="common-text">"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Doloribus nisi enim quo quasi facilis reprehenderit accusamus qui culpa error eius aut adipisci sunt, nesciunt optio? Ducimus sed debitis,"</p>
                                                <h3>- John Doe</h3>
                                            </div>
                                        </SwiperSlide>
                                    </Swiper>
                                </div>

                                <div className="arrow-slider-box">
                                    <i onClick={handlePrev} className="fas fa-chevron-left"></i>
                                    <i onClick={handleNext} className="fas fa-chevron-right"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ConsumerSay